import { Card } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const performanceData = [
  { time: "0s", loadTime: 2.1, fcp: 1.8, lcp: 2.5 },
  { time: "1s", loadTime: 1.9, fcp: 1.6, lcp: 2.3 },
  { time: "2s", loadTime: 2.3, fcp: 1.9, lcp: 2.7 },
  { time: "3s", loadTime: 2.0, fcp: 1.7, lcp: 2.4 },
  { time: "4s", loadTime: 1.8, fcp: 1.5, lcp: 2.2 },
];

export const PerformanceMetrics = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Page Performance</h3>
      <div className="h-[300px]">
        <ChartContainer
          config={{
            loadTime: {
              label: "Load Time",
              theme: {
                light: "hsl(var(--primary))",
                dark: "hsl(var(--primary))",
              },
            },
            fcp: {
              label: "First Contentful Paint",
              theme: {
                light: "hsl(var(--destructive))",
                dark: "hsl(var(--destructive))",
              },
            },
            lcp: {
              label: "Largest Contentful Paint",
              theme: {
                light: "hsl(var(--accent))",
                dark: "hsl(var(--accent))",
              },
            },
          }}
        >
          <LineChart data={performanceData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip content={<ChartTooltipContent />} />
            <Line
              type="monotone"
              dataKey="loadTime"
              stroke="hsl(var(--primary))"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="fcp"
              stroke="hsl(var(--destructive))"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="lcp"
              stroke="hsl(var(--accent))"
              strokeWidth={2}
            />
          </LineChart>
        </ChartContainer>
      </div>
    </Card>
  );
};